export default {
  apiKey: "AIzaSyBkwByXhFLBBCt1wVEnoGUC9E-W4-ZOxp0",
  authDomain: "todo-list-1-900db.firebaseapp.com",
  databaseURL: "https://todo-list-1-900db.firebaseio.com",
  projectId: "todo-list-1-900db",
  storageBucket: "todo-list-1-900db.appspot.com",
  messagingSenderId: "970542818787",
  appId: "1:970542818787:web:c82974fb159bfe60a66cd6",
  measurementId: "G-65ZSMKM1EG",
};
